import React from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer'

export default () => {
  return (
    <>
      <Header />
      <div className={'container'}>
        <h1>404 - Not Found</h1>
      </div>
      <Footer />
    </>
  )
}
